import {ConfigurationRepository} from '@infra/domain/model/Config/ConfigurationRepository';
import {RetrieveConfiguration} from '@application/Config/RetrieveConfiguration';

export const ConfigurationApplication = {
  retrieve: RetrieveConfiguration(ConfigurationRepository),
};
